'use client';

import { type Icon } from '@tabler/icons-react';

import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/ui/sidebar';
import { Link, useLocation } from 'react-router-dom';
import { PermissionGate } from './auth/PermissionGate';

export function NavSystemManagement({
  items,
}: {
  items: {
    title: string;
    url: string;
    icon?: Icon;
    permission?: string;
  }[];
}) {
  const location = useLocation();

  return (
    <SidebarGroup className="group-data-[collapsible=icon]:hidden">
      <SidebarGroupLabel>System Management</SidebarGroupLabel>
      <SidebarMenu>
        {items.map((item) => {
          const isActive =
            location.pathname === item.url ||
            (item.url === '/' && location.pathname === '/');

          const menuItem = (
            <SidebarMenuItem
              key={item.title}
              data-testid={`${item.title.toLowerCase()}-nav`}
            >
              <SidebarMenuButton
                tooltip={item.title}
                asChild
                isActive={isActive}
              >
                <Link
                  to={item.url}
                  data-testid={`nav-link-${item.title.toLowerCase()}`}
                >
                  {item.icon && <item.icon />}
                  <span>{item.title}</span>
                </Link>
              </SidebarMenuButton>
            </SidebarMenuItem>
          );

          // Wrap with permission gate if permission is specified
          return item.permission ? (
            <PermissionGate key={item.title} permission={item.permission}>
              {menuItem}
            </PermissionGate>
          ) : (
            menuItem
          );
        })}
      </SidebarMenu>
    </SidebarGroup>
  );
}
